// extracted by mini-css-extract-plugin
export var columnList = "_fp-0";